//export const API_URL = "https://subdomain-dev.docandtee.com/api/";
// export const API_URL = "/api/";
export const API_URL = document.getElementById('app').dataset.apiUrl;
console.log('API URL', API_URL);
export default API_URL;
